import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/system', // 系统
  name: 'system',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.system',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 7,
  },
  children: [
       {
      path: 'serveiceManage', // The midline path complies with SEO specifications
      name: 'serveiceManage',
      component: () => import('@/views/system/service/index.vue'),
      meta: {
        locale: 'menu.serveiceManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
         {
      path: 'modelManage', // The midline path complies with SEO specifications
      name: 'modelManage',
      component: () => import('@/views/system/model/index.vue'),
      meta: {
        locale: 'menu.modelManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'userManage', // The midline path complies with SEO specifications
      name: 'userManage',
      component: () => import('@/views/system/user/index.vue'),
      meta: {
        locale: 'menu.userManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'appManage', // The midline path complies with SEO specifications
      name: 'appManage',
      component: () => import('@/views/system/app/index.vue'),
      meta: {
        locale: 'menu.appManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'setting',
      name: 'Setting',
      component: () => import('@/views/user/setting/index.vue'),
      meta: {
        locale: 'menu.user.setting',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
